// Migrated 1:1 from @nexato/nx-core-module (components/billing-invoice-receiver-edit-address-dialog, #685)
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Tenant } from '../../entities/tenant/tenant';
import { GroupsService } from '../../services/groups/groups.service';
import { LoadingService } from '../../services/loading.service';
import { LocationService } from '../../services/location/location.service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { UsersService } from '../../services/users/users.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-billing-invoice-receiver-edit-address',
  templateUrl: './billing-invoice-receiver-edit-address.component.html',
  styleUrls: ['./billing-invoice-receiver-edit-address.component.scss']
})
export class BillingInvoiceReceiverEditAddressDialogComponent
  implements EditDialogInstance {

    invoiceAddressForm: FormGroup;
    tenant: Tenant;
    vatTypeOptions: any[];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public userService: UsersService,
    public groupService: GroupsService,
    public loadingService: LoadingService,
    public locationService: LocationService,
    public tenantService: TenantsService
  ) {

    this.vatTypeOptions = tenantService.getVatTypes();

    if (this.config.data) {
      this.tenant = this.config.data;
    }

    this.invoiceAddressForm = new FormGroup({});
    this.invoiceAddressForm.addControl('id', new FormControl());
    this.invoiceAddressForm.addControl('name', new FormControl(undefined, Validators.required));
    this.invoiceAddressForm.addControl('addressLine0', new FormControl(undefined, Validators.required));
    this.invoiceAddressForm.addControl('addressLine1', new FormControl());
    this.invoiceAddressForm.addControl('postalCode', new FormControl(undefined, Validators.required));
    this.invoiceAddressForm.addControl('city', new FormControl(undefined, Validators.required));
    this.invoiceAddressForm.addControl('country', new FormControl(undefined, Validators.required));
    this.invoiceAddressForm.addControl('vatNumber', new FormControl(undefined, Validators.required));
    this.invoiceAddressForm.addControl('vatNumber', new FormControl( undefined, [Validators.required, this.tenantService?.vatNumberValidator()]));
    this.invoiceAddressForm.addControl('vatType', new FormControl( undefined, Validators.required));
    if(this.tenant){
      this.invoiceAddressForm.patchValue(this.tenant?.invoiceAddress);
      this.invoiceAddressForm.get('id')?.setValue(this.tenant?.id);
    }
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    this.tenantService?.updateInvoiceAddress(this.invoiceAddressForm.value, () => {
      this.loadingService.setLoading(false);
      this.ref.close(true);
    });
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.invoiceAddressForm;
  }
}
